import { IRootState } from '..';

export const SELECTOR_AUTOPLAY_AUTOPLAY_ENABLED = (state: IRootState) => state.Autoplay.autoplayEnabled;
export const SELECTOR_AUTOPLAY_IS_AUTOPLAY_VISIBLE = (state: IRootState) => state.Autoplay.isAutoplayVisible;
